module.exports = __webpack_public_path__ + "img/realestate_structure_infogp.68d97524.png";